export default {
  noRecords: 'No recent records found.',
  inBound: 'Inbound',
  outBound: 'Outbound',
  missed: 'Missed Call'
};
